import { render, staticRenderFns } from "./BannerRegulamento.vue?vue&type=template&id=54946824&"
import script from "./BannerRegulamento.vue?vue&type=script&lang=js&"
export * from "./BannerRegulamento.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports